// test940
(940 && 0);
